var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLanguage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5811_53)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6612 19.6932L13.1976 16.2705L13.2385 16.2296C15.6112 13.5841 17.3021 10.5432 18.2976 7.32498H22.2931V4.59091H12.7476V1.86362H10.0203V4.59091H0.474854V7.30453H15.7067C14.7862 9.93633 13.3475 12.4318 11.3839 14.6136C10.1157 13.2023 9.0657 11.6682 8.23391 10.0454H5.50668C6.50211 12.2681 7.86579 14.3682 9.57029 16.2636L2.6362 23.1159L4.56577 25.0455L11.384 18.2273L15.6249 22.4682L16.6612 19.6932Z",
    fill: "#017E89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3385 12.7727H21.6112L15.4749 29.1364H18.2021L19.7362 25.0455H26.2135L27.7476 29.1364H30.4749L24.3385 12.7727ZM20.759 22.3182L22.9749 16.4068L25.1908 22.3182H20.759Z",
    fill: "#017E89"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5811_53"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(0.474854 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguage);
export default __webpack_public_path__ + "static/media/language.99ffb351566477725e4f2ed0c5e4f284.svg";
export { ForwardRef as ReactComponent };